// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__3t_0p","pageContent":"Page_pageContent__3XETn","pageTitle":"Page_pageTitle__16owk"};